<p-toast></p-toast>
<div class="vendor-associate mx-0 my-0 py-0">
    <div class="p-fluid p-formgrid justify-content-center mx-0 my-0 py-0" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12 mx-0 my-0">
            <div class="grid-item">
                <p-dropdown [options]="vendorList" [(ngModel)]="selectedVendor" (onChange)="onSelectVendor()"
                    appendTo="body" placeholder="{{ 'Select Vendor'| translate }}"
                    optionLabel="VendorName"></p-dropdown>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2 dashboardTable" *ngIf="showDetailTable">
    <p-table #addedCompTable [value]="vendorAccociateList" [rows]="10" [paginator]="true" responsiveLayout="scroll"
        [rowHover]="true" dataKey="Mobile" [loading]="loadingData"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}"
        [globalFilterFields]="[
        'Name', 
        'AadharNo', 
        'Mobile', 
        'WorkType', 
        'Photo', 
        'Signature', 
    ]">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <!-- Left side -->
                <div class="col-5 flex justify-content-start">
                    <h5 [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around' }">
                        {{ "Added Associate Details" | translate }}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-3 d-flex justify-content-between">
                    <p-splitButton [model]="menuItems" icon="pi pi-download"
                        label="{{'EXPORT' | translate}}"></p-splitButton>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button> -->
                    <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
                    <!-- <p-menu #menu [popup]="true" [model]="addedCompTableExport"></p-menu> -->
                </div>
                <!-- Right side for search -->
                <div class="col-4 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="addedCompTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!-- <th pSortableColumn="VendorAssociateId">{{'Associate Id'| translate}}</th> -->
                <th pSortableColumn="Name">{{'NAME'| translate}}</th>
                <th pSortableColumn="AadharNo">{{'AADHAR_NO'| translate}}</th>
                <th pSortableColumn="Mobile">{{'MOBILE_NO'| translate}}</th>
                <th pSortableColumn="WorkType">{{'WORK_TYPE'| translate}}</th>
                <th>{{'PHOTO'| translate}}</th>
                <th>{{'SIGNATURE'| translate}}</th>
                <th>{{'STATUS'| translate}}</th>
                <th>{{'ACTIONS'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-Index="rowIndex">
            <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(rowData)}">
                <!-- <td>{{ Index + 1 }}</td> -->
                <!-- <td>{{rowData?.VendorAssociateId}}</td> -->
                <td>{{rowData?.Name}}</td>
                <td>{{rowData?.AadharNo}}</td>
                <td>{{rowData?.Mobile}}</td>
                <td>{{rowData?.WorkType}}</td>
                <td>
                    <a *ngIf="rowData?.Photo && rowData?.Photo != 'string'" style="cursor: pointer" icon="pi pi-eye"
                        [href]="rowData?.Photo" target="_blank">
                        <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded" pTooltip="View"
                            icon="pi pi-eye"></button>
                    </a>
                </td>
                <td>
                    <a *ngIf="rowData?.Signature && rowData?.Signature != 'string'" style="cursor: pointer"
                        icon="pi pi-eye" [href]="rowData?.Signature" target="_blank">
                        <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded" pTooltip="View"
                            icon="pi pi-eye"></button>
                    </a>
                </td>
                <td>{{rowData?.ApprovalStatus}}</td>
                <td>
                    <button *ngIf="rowData?.ApprovalStatus == 'Pending'" pButton pRipple type="button" icon="pi pi-plus"
                        (click)="onClickActionRow(rowData)"
                        class="p-button-rounded p-button-text p-button-info"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">

        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <!-- <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }}
                    {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                </p> -->
                <div class="flex  justify-content-between flex-column ">
                    <div class="flex">
                        <div
                            style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'PENDING'| translate}}
                    </div>
                    <div class="flex">
                        <div
                            style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'APROVED'| translate}}
                    </div>
                </div>
            </div>
        </ng-template>

    </p-table>
</div>

<p-dialog header="Vendor Associate Action" [baseZIndex]="-100" [(visible)]="showActionDialog" [modal]="true"
    [style]="{width: '70%',height:'auto'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    (onHide)="onCloseActionDialog()">

    <div class="p-fluid p-formgrid justify-content-center vendor-action-details" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRowForAction?.Name
                    }}</label></label>
        </div>

        <div class="field md:col-4 col-12">
            <label>{{'MOBILE_NO'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedRowForAction?.Mobile }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'WORK_TYPE'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedRowForAction?.WorkType }}</label></label>
        </div>
    </div>

    <div class="card submit-card mt-2">
        <div class="p-fluid p-formgrid grid">
            <div class="col-12 md:col-4">
                <p-dropdown [options]="actionItems" [(ngModel)]="selectedStatus"
                    placeholder="{{ 'ACTION_TYPE'| translate }}" optionLabel="status" class="mr-3">
                </p-dropdown>
            </div>
            <div class="col-12 md:col-4">
                <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required rows="3"
                    cols="20" class="mr-3"></textarea>
            </div>
            <div class="col-12 md:col-4">
                <button [disabled]="!selectedStatus" pButton pRipple label="Submit" (click)="onClickSubmit()"
                    class="p-button-success"></button>
            </div>
        </div>
    </div>
</p-dialog>